import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

export interface Boton{
  texto : string;
  evento : string;
  parametros : any;
}

export interface DialogData {
  title: string;
  mensaje: string;
  tipo : number;
  target : any;
  botones : Boton[];  
}

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<ModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) { }

  ngOnInit(): void {
  }

  /**
   * 
   * @param target objetivo que lanza el evento del modal, debe estar en el componente que levanta el modal.
   * @param evento evento que ejecutara la funcion
   * @param json_parametros parametro que se el enviaran al evento.
   */
  public lanzar_evento(target, evento, json_parametros){

    let obj_evento = new CustomEvent(evento, {detail : json_parametros});
    target.dispatchEvent(obj_evento);
  }

}
